const messages = {
  title: "Produkte & Medien",
  title_media: "Produktinformationen & Medien",
  description:
    "Hier stehen Ihnen eine Vielzahl von Produktunterlagen und Medien unserer Marken Bridgestone und Firestone sowie weiteren Reifenlösungen zur Verfügung. Nutzen Sie Medien verschiedene Filteroptionen oder geben Sie gezielte Suchanfragen in das Suchfeld ein, um das Gewünschte schnell zu finden. ",
  short_description:
    "Produktbroschüren, Preislisten, Pricat Dateien, Logos, Inhalte für Social Media, Instore-TV und mehr.",
  mediaCategories: {
    products: "Produkte",
    brand_and_solutions: "Marke & Lösungen",
    season_and_promotions: "Saison & Aktionen",
    format: "Format",
    cars_and_vans: "Pkw & Transporter",
    truck_and_buses: "Lkw & Bus",
    motorcycle: "Motorradrrad",
    agriculture: "Landwirtschaft",
    construction_machinery: "Baumaschinen",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialien",
    brochures: "Produktbroschüren",
    price_list: "Preislisten",
    materials: "Materialien",
    video_in_store: "Video mit Untertitel",
    video_online: "Video ohne Untertitel",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Social Media",
    logos: "Logos",
    summer: "Sommer",
    winter: "Winter",
    all_season: "All Season",
    promotions: "Aktionen",
    price: "Pricat",
  },
  mediasPage: {
    title: "Produkte & Medien",
    description:
      "Willkommen im Medienbereich von Bridgestone und Firestone.<br><br>" +
      "Hier finden Sie eine zentral gebündelte Auswahl freigegebener Marketingmaterialien für Ihre tägliche Arbeit – darunter Produktabbildungen, Logos, Banner, Videos und weitere digitale Assets.<br><br>" +
      "Alle Inhalte stehen Ihnen zur unkomplizierten Nutzung auf Ihrer Website, in Online-Shops sowie für Social-Media-Aktivitäten zur Verfügung und werden regelmäßig aktualisiert.",
    bDrive: {
      title: "Profilabbildungen",
      description: "Aktuelle Bilder vom B-DRIVE Portal herunterladen.",
    },
  },
  buttons: {
    media: "ENTDECKEN",
  },
  searchMedia: "Suchbegriff eingeben",
  searchResults: "Suchergebnisse",
};

export default {
  messages,
};
